import React from 'react'
import Story from './story'
import ThumbnailGrid from '../ThumbnailGrid';

class PhotosStory extends Story {
  constructor(props) {
    super(props);

    this.state = {
      story: props.story,
      entity: props.story.entity,
      payload: props.story.payload,
      project: props.story.payload[0]
    }
  }

  getImages() {
    const payload = this.state.payload;

    return payload.slice(1, payload.length).map(image => {
      return {
        src: image.image,
        alt: image.title,
        link: this.state.project.url,
      }
    });
  }

  render() {
    const project = this.state.project;
    const entity = this.state.entity;
    const images = this.getImages();

    const caption = this.captionWithEntity(I18n.t('jslibrary.stream.photographer_in_project', {
      count: images.length,
      photographer: entity.name,
      url: project.url,
      project: project.title,
    }), entity);

    return (
      <div className="afd-story" data-insights-category="myad-feed" data-insights-label="photo-story" data-insights-value={project.url}>
        <ThumbnailGrid max={5} cols={3} thumbs={images} />

        <p className="afd-story__caption">{caption}</p>
      </div>
    )
  }
}

export default PhotosStory;